export default "__VITE_ASSET__DNOYgnkZ__"